//export const baseUrlApi = "http://127.0.0.1:8000/api"
//export const baseUrlApi = "http://127.0.0.1:8080/api";
export const baseUrlApi = "https://adm.tagaautopartes.com.br/api";
//export const baseUrlApi = "https://symbol-template-fruit-experiences.trycloudflare.com/api";